import { render, staticRenderFns } from "./fromContent.vue?vue&type=template&id=0c775ce6&scoped=true&"
import script from "./fromContent.vue?vue&type=script&lang=js&"
export * from "./fromContent.vue?vue&type=script&lang=js&"
import style0 from "./fromContent.vue?vue&type=style&index=0&id=0c775ce6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c775ce6",
  null
  
)

export default component.exports